import { Link, useLocation } from "react-router-dom";
import { Alert, Icon } from "@app/ui";
import { useOrgs } from "../orgs/OrgContext.js";
import { useT } from "../i18n.js";

/** Platform-wide pages: the selected org is irrelevant there, so no banner. */
const PLATFORM_PATHS = ["/platform", "/users", "/audit", "/license", "/profile"];

/**
 * Shown when a platform admin is working inside an org they are NOT a member
 * of (cross-tenant access). Every change they make lands in that customer's
 * data and audit trail, so it must never look like their own workspace.
 */
export function PlatformAccessBanner() {
  const t = useT();
  const { org } = useOrgs();
  const { pathname } = useLocation();
  if (!org?.viaPlatform || PLATFORM_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)))
    return null;
  return (
    <Alert type="info" className="app-banner" icon={false}>
      <div className="app-banner-row">
        <span className="app-banner-msg">
          <Icon name="shield" size={14} />
          {t("platform.viaPlatformBanner", { org: org.name })}
        </span>
        <Link to="/platform/orgs">{t("platform.backToConsole")}</Link>
      </div>
    </Alert>
  );
}
